/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {Component, OnInit, Renderer2} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {ThemeState} from './state/theme.state';
import {Observable} from 'rxjs';
import {SetThemeVariant, ThemeVariantPayload, ThemeVariantType} from './state/theme.actions';
import {GoogleMapService} from '../../../modules/map/services/googleMap.service';

@Component({
    selector: 'dash-gis-theme-switcher',
    template: `
        <button mat-icon-button
                matTooltip="Toggle Light/Dark Theme"
                (click)="toggleLightDark()">
            <mat-icon svgIcon="theme-toggle"></mat-icon>
        </button>`
})
export class ThemeSwitcherComponent implements OnInit {

    @Select(ThemeState.variant) private themeVariant$: Observable<ThemeVariantType>;

    constructor(
        private renderer: Renderer2,
        private gMapService: GoogleMapService,
        private store: Store,
    ) {}

    ngOnInit() {
        this.themeVariant$.subscribe((variant) => {
            switch (variant) {
                case 'light':
                    this.setLightTheme();
                    break;
                case 'dark':
                    this.setDarkTheme();
                    break;
            }
        });
    }

    toggleLightDark() {
        this.store.selectOnce(ThemeState.variant)
            .subscribe((variant) => {
                const payload: ThemeVariantPayload = {
                    variant: (variant === 'light') ? 'dark' : 'light'
                };
                this.store.dispatch(new SetThemeVariant(payload));
            });
    }

    setLightTheme() {
        const classes = document.body.classList;
        if (classes.contains('dash-gis-dark-theme')) {
            this.renderer.removeClass(document.body, 'dash-gis-dark-theme');
            this.renderer.addClass(document.body, 'dash-gis-light-theme');
        }
    }

    setDarkTheme() {
        const classes = document.body.classList;
        if (classes.contains('dash-gis-light-theme')) {
            this.renderer.removeClass(document.body, 'dash-gis-light-theme');
            this.renderer.addClass(document.body, 'dash-gis-dark-theme');
        }
    }
}
